import { useEffect, useState } from 'react';
import type { EbookAttempt } from '@wx-weiqi/contracts';
import './ebook-result.css';

/** Presentation only: the server (or authorized teacher preview) supplies the outcome. */
export function EbookResultFeedback({
  status,
  feedback,
  busy,
  onReturn,
}: {
  status: EbookAttempt['status'];
  feedback: string;
  busy: boolean;
  onReturn: () => void;
}) {
  const correct = status === 'CORRECT';
  const incorrect = status === 'INCORRECT';
  const graded = correct || incorrect;
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (!graded) return;
    const timer = window.setTimeout(() => setVisible(false), 2_000);
    return () => window.clearTimeout(timer);
  }, [graded]);
  if (!visible) return null;
  return (
    <section
      className={`ebook-board-feedback is-${correct ? 'correct' : incorrect ? 'incorrect' : 'pending'}`}
      data-outcome={status}
      aria-label="本题作答结果"
    >
      {graded && (
        <div className="ebook-feedback-ornaments" aria-hidden="true">
          {[0, 1, 2, 3].map((corner) => (
            <svg key={corner} viewBox="0 0 60 60">
              <path d="M2 48V22Q2 2 22 2H48 M9 42V23Q9 9 23 9H42" />
              <path d="M12 31C31 37 39 16 25 14C12 12 13 27 23 25 M31 12C37 31 16 39 14 25" />
              <circle cx="45" cy="8" r="3" />
            </svg>
          ))}
        </div>
      )}
      {graded && (
        <img
          className="ebook-feedback-art"
          src={`/assets/ebook-feedback/${correct ? 'correct' : 'retry'}-companions.png`}
          width="1536"
          height="1024"
          alt=""
          aria-hidden="true"
          draggable={false}
        />
      )}
      <div className="ebook-feedback-copy" role="status" aria-live="polite" aria-atomic="true">
        <span className="ebook-feedback-kicker">
          {correct ? '本题答对 · 已完成' : incorrect ? '本题答错 · 未通过' : '作答已保存 · 待批改'}
        </span>
        <h2>
          {correct
            ? '答对啦！'
            : incorrect
              ? '答错了'
              : status === 'UNKNOWN'
                ? '这个变化，留给老师看看'
                : '作答已提交，等待老师批改'}
        </h2>
        <p className="ebook-feedback-detail">
          {correct
            ? '太棒了！这是一手好棋！'
            : incorrect
              ? '下一题你一定可以的！'
              : '本次作答已保留，暂不计为正确或错误。'}
        </p>
        {feedback && <p className="ebook-feedback-note">{feedback}</p>}
      </div>
      {!graded && (
        <button className="ebook-feedback-return" onClick={onReturn} disabled={busy}>
          返回
        </button>
      )}
    </section>
  );
}
